import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import {createBrowserRouter, createRoutesFromElements, Route, RouterProvider} from 'react-router-dom'
import store from './store';
import {Provider} from 'react-redux';
import PrivateRoute from './components/PrivateRoute.js';
import LoginScreen from './screens/LoginScreen';
import RegisterScreen from './screens/RegisterScreen';
import ForgotpasswordScreen from "./screens/ForgotpasswordScreen";
import PasswordresetScreen from './screens/PasswordresetScreen.js';

import DashboardScreen from './screens/DashboardScreen';
import PublicRoute from './components/PublicRoute.js';
import FreeRoute from './components/FreeRoute.js';
import DailyJournalScreen from './screens/DailyJournalScreen.js';
import TradeLogsScreen from './screens/TradeLogsScreen.js';
import StrategyScreen from './screens/StrategyScreen.js';
import ProfileScreen from './screens/ProfileScreen.js';
import SubscriptionScreen from './screens/SubscriptionScreen.js';
import PaymentSuccessScreen from './screens/PaymentSuccessScreen.js';
import PaymentFailedScreen from './screens/PaymentFailedScreen.js';
import ReportScreen from './screens/ReportScreen.js';
import CoursesScreen from './screens/CoursesScreen.js';
import NotesScreen from './screens/NotesScreen.js';
import ImportScreen from './screens/ImportScreen.js';
import AdminRoute from './components/AdminRoute.js';
import AdminUsersScreen from './screens/Admin/AdminUsersScreen.js';
import AdminPackagesScreen from './screens/Admin/AdminPackagesScreen.js';
import AdminCoursesScreen from './screens/Admin/AdminCoursesScreen.js';
import AdminPaymentsScreen from './screens/Admin/AdminPaymentsScreen.js';
import SubRoute from './components/SubRoute.js';
import AdminDashboardScreen from './screens/Admin/AdminDashboardScreen.js';
import TradeCalendar from './screens/customeCalender.js';
import ApiKeyForm from './screens/Admin/Form/apiKeyForm.js';
import DownlinePage from './screens/global/DownlineUser.js';
import BankDetailsScreen from './screens/Admin/Form/BankForm.js';
import WithdrawScreen from './screens/WithdrawScreen.js';
import WalletHistoryPage from './screens/global/walletHistory.js';
import AdminWalletHistoryPage from './screens/Admin/AdminWalletHistroyPage.js';
import CreateStrategy from './screens/Admin/Form/stratgyForm.js';
import Dashboard from './screens/AllStratergy.js';


const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path='/' element={<App/>}>
      <Route path="" element={<PublicRoute />}>
      <Route path="/" element={<LoginScreen/>} />
        <Route path="/login" element={<LoginScreen/>} />
        <Route path="/register" element={<RegisterScreen/>} />
        <Route path="/forgotpassword" element={<ForgotpasswordScreen/>} />
        <Route path="/passwordreset/:id" element={<PasswordresetScreen/>} />
      </Route>
      <Route path="" element={<PrivateRoute />}>
        <Route path="" element={<SubRoute />}>
          <Route path="/Dashboard" element={<DashboardScreen />} />
          <Route path='/ImportTrades' element={<ImportScreen />}/>
          <Route path="/DailyJournal" element={<DailyJournalScreen />} />
          <Route path="/Notes" element={<NotesScreen />} />
          <Route path="/TradeLogs" element={<TradeLogsScreen />} />
          <Route path="/apikeyform" element={<ApiKeyForm />} />



        </Route>
        <Route path="" element={<FreeRoute />}>
          <Route path="/Reports" element={<ReportScreen />} />
          <Route path="/Courses" element={<CoursesScreen />} />
          <Route path="/downline" element={<DownlinePage />} />
          <Route path="/bank-details" element={<BankDetailsScreen />} />
          <Route path="/withdraw" element={<WithdrawScreen />} />
          <Route path="/wallet-history" element={<WalletHistoryPage />} />
          <Route path="/Create-Strategy" element={<CreateStrategy/>} />
                    <Route path="/all-Strategy" element={<Dashboard/>} />




        </Route>
        <Route path="/Profile" element={<ProfileScreen />} />
                   <Route path="/calender" element={<TradeCalendar />} />

        <Route path="/PaymentSuccess" element={<PaymentSuccessScreen />} />
        <Route path="/PaymentFailed" element={<PaymentFailedScreen />} />
        <Route path="/Subscription" element={<SubscriptionScreen />} />
      </Route>
      <Route path="" element={<AdminRoute />}>
        <Route path="/Lincfolioadm/users" element={<AdminUsersScreen />} />
        <Route path='/Lincfolioadm/packages' element={<AdminPackagesScreen />}/>
        <Route path="/Lincfolioadm/courses" element={<AdminCoursesScreen />} />
        <Route path="/Lincfolioadm/payments" element={<AdminPaymentsScreen />} />
        <Route path="/Lincfolioadm/dashboard" element={<AdminDashboardScreen />} />
                <Route path="/Lincfolioadm/walletHistory" element={<AdminWalletHistoryPage />} />

      </Route>
    </Route>
  )
)


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
      <RouterProvider router={router} />
  </Provider>
);
